
import EntryExitInvoicing from "models/entry-exit-invoicing";
import { getDecimal } from "common/js/util";
export default {
  data() {
    return {
      invoiceTable: [],
      invoiceTableTitle: [
        { prop: 'name', label: '商品或劳务名称' },
        { prop: 'goodsQuantity', label: '数量' },
        { prop: 'unitLocalPrice', label: '本币单价' },
        { prop: 'totalLocalPrice', label: '本币总价' }
      ],
      // 科目明细表头
      subjectDetailsTableTitle: [
        { prop: '', label: '', width: '32' },
        { prop: 'feeName', label: '科目明细名称', width: '' },
        { prop: '', label: '', width: '' },
        { prop: '', label: '', width: '' },
        { prop: 'localPrice', label: '本币金额', width: '' },
        { prop: 'price', label: '金额', width: '' }
      ],
    }
  },
  created() {
  },
  methods: {
    /** 
     * @description 发票明细列表
     * @param {Array} list 发票明细列表
    */
    initInvoiceTable(list) {
      let arr = []
      list.map(i => {
        let obj = {}
        obj.id = i.id
        obj.invoiceId = i.invoiceId
        obj.goodsReceiptId = i.goodsReceiptId
        obj.name = i.goodsReceiptName
        obj.goodsQuantity = i.goodsQuantity
        obj.unitLocalPrice = i.unitLocalPrice
        obj.totalLocalPrice = i.totalLocalPrice
        obj.children = []
        i.orderFeeDetailList.map(j => {
          let obj2 = {}
          obj2.id = j.id
          obj2.feeName = j.feeName
          obj2.localPrice = j.localPrice
          obj2.price = j.price
          obj.children.push(obj2)
        })
        arr.push(obj)
      })
      this.invoiceTable = arr
    },

    //限制发票数量
    inputNums(index, num) {
      let goodsQuantity = getDecimal(num);
      this.invoiceTable[index].goodsQuantity = goodsQuantity;
    },

    //限制发票单价
    inputUnitPrice(index, price) {
      let unitLocalPrice = getDecimal(price);
      this.invoiceTable[index].unitLocalPrice = unitLocalPrice;
    },

    //限制发票原币总价
    inputTotalLocalPrice(index, price) {
      let totalLocalPrice = getDecimal(price);
      if (totalLocalPrice > this.invoiceTable[index].billTotalPrice) totalLocalPrice = 0
      this.invoiceTable[index].totalLocalPrice = totalLocalPrice;
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = '账单总价（原币）合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },

    saveInvoicingDetails(row) {
      let goodsQuantity = row.goodsQuantity
      let unitLocalPrice = row.unitLocalPrice
      let totalLocalPrice = row.totalLocalPrice
      let data = {
        goodsQuantity,
        unitLocalPrice,
        totalLocalPrice
      }
      EntryExitInvoicing.postSaveInvoicingDetails(row.id, data).then(res => {
        if (res.success) {
          this.$message.success('发票明细保存成功');
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
}